import { NgModule } from '@angular/core';
import { LoadingDirective } from '../directives/loading.directive';
import { LoadingSpinnerComponent } from '../components/dialogs/loading-spinner/loading.spinner.component';
import { AppDynamicComponent } from 'src/app/shared/components/dynamic-component-shared/app-dynamic.component';
import { AppUIBuilderComponent } from '../app-ui-builder/app-ui-builder.component';
import { TableComponent } from '../components/dynamic-component-shared/table/table.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MaterialModules } from './material.module';
import { AuthenticationService } from '../services/authentication.service';
import { EntiteDirective } from '../directives/entite.directives';
import { EntityService } from 'src/app/admin/core/services/entity.service';
import { LoadingInterceptor } from '../core/loading-interceptor';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { LoadingService } from '../services/loading.service';
import { AlertService } from '../services/alert-service';
import { DialogComponent } from '../components/dialogs/dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateDynamicLanguagePipe } from 'src-ironside/pipes/translateDynamicLanguage.pipe';
import { TranslateDynamicLanguageTablePipe } from 'src-ironside/pipes/translateDynamicLanguageTable.pipe';
import { DashToSpacePipe } from 'src-ironside/pipes/dash-to-space.pipe';

@NgModule({
  imports: [MaterialModules],
  declarations: [
    LoadingDirective,
    LoadingSpinnerComponent,
    AppDynamicComponent,
    AppUIBuilderComponent,
    TranslateDynamicLanguagePipe,
    TranslateDynamicLanguageTablePipe,
    DashToSpacePipe,
  ],
  exports: [
    LoadingDirective,
    LoadingSpinnerComponent,
    AppDynamicComponent,
    AppUIBuilderComponent,
    TranslateModule,
    TranslateDynamicLanguagePipe,
    TranslateDynamicLanguageTablePipe,
    DashToSpacePipe

  ],
  providers: [
    LoadingService,
    AlertService,
    AuthenticationService,
    EntityService,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  ],
})
export class SharedModule {}
